import { useEffect } from "react";
import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@/react/contexts";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";
import { usePlans } from "@circle-react/components/SettingsApp/Plan/RegularPlan/PlansContext";
import { Loader } from "@circle-react-uikit/Loader";
import Features from "../Features";
import { PlanSelector } from "../PlanSelector";
import { TopSection } from "../TopSection";
import { PlanSummary } from "./PlanSummary";
import socialProof from "./socialProof.svg";

const localeRoot = "pricing_plans.plan_settings.plan_selection";

export const PlanSelectorVariantC = () => {
  const { isLoading: isCurrentCommunityLoading } = usePunditUserContext();
  const { isCurrentPlanLoading } = usePlans();

  const { trackEvent } = useEventsTracker();

  useEffect(() => {
    trackEvent("plan_settings.plans_page.visited", {});
  }, [trackEvent]);

  if (isCurrentPlanLoading || isCurrentCommunityLoading) {
    return <Loader variant="fullscreen" />;
  }

  return (
    <div className="flex flex-col gap-10">
      <TopSection />
      <div className="flex gap-6">
        <div className="flex min-w-[681px] flex-col gap-10">
          <PlanSelector />
          <img
            src={socialProof}
            loading="lazy"
            alt={t([localeRoot, "title"])}
          />
          <Features />
        </div>
        <div>
          <PlanSummary />
        </div>
      </div>
    </div>
  );
};
